<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      const classes = ['svg-icon']
      if (this.className) {
        classes.push(this.className)
      }
      if (/^(tabler|lucide)-/.test(this.iconClass)) {
        classes.push('svg-icon--stroke')
      }
      return classes.join(' ')
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1.2em;
  height: 1.2em;
  vertical-align: -0.18em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon--stroke {
  fill: none;
  stroke: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue